/**
 * Sets the time of given date to 00:00:00 (start of the day)
 *
 * @param date - Date | string
 * @return result - Date
 */
export const startOfDay = (date: Date | string): Date => {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);

  return result;
};

/**
 * Sets the time of given date to 24:00:00 (end of the day)
 *
 * @param date - Date | string
 * @return result - Date
 */
export const endOfDay = (date: Date | string): Date => {
  const result = new Date(date);
  result.setHours(23, 59, 59, 999);

  return result;
};
